import { IMAGE_BASE_URL } from "../services/api";

export const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url.replace('localhost', '192.168.0.175');
  if (url.startsWith('/uploads/')) return `${IMAGE_BASE_URL}${url}`;
  
  let cleanUrl = url.replace(/^\//, '').replace('li stings', 'listings');
  return `${IMAGE_BASE_URL}/uploads/${cleanUrl}`;
};